import { render, staticRenderFns } from "./TransactionContentSet.vue?vue&type=template&id=9d7b6c22&"
import script from "./TransactionContentSet.vue?vue&type=script&lang=ts&"
export * from "./TransactionContentSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports